import { createModelSchema, identifier, primitive } from 'serializr';
import { emailTemplateSettingsSchema } from '../shared/emailtemplate-base';

export default class ModelSchemas {
    static createTcFileSchema(model, props) {
        // TcFile
        return createModelSchema(
            model,
            Object.assign(
                {
                    tcFileId: identifier(),
                    title: primitive(),
                    propertyAddress: primitive(),
                    typeOfSale: primitive(),
                    propertyType:primitive(), 
                    status: primitive(),
                    origin: primitive(),
                    fileSubmissionDate: primitive(),
                    estimatedCloseDate: primitive(),
                    actualCloseDate: primitive(),
                    daysInEscrow: primitive(),
                    survey: primitive(),
                    hud: primitive(),
                    thumbDrive: primitive(),
                    coordinatorId: primitive(),
                    subscriberName: primitive(),
                    notes: primitive(),
                    checkStatus: primitive(),
                    checkNumber: primitive(),
                    checkAmount: primitive(),
                    depositDate: primitive(),
                    originId: primitive(),
                    subscriberId: primitive(),
                    transactionId: primitive(),
                    address1: primitive(),
                    address2: primitive(),
                    city: primitive(),
                    state: primitive(),
                    county: primitive(),
                    zip: primitive(),
                    direction: primitive(),
                    unitNum: primitive(),
                    originatedFromListing: primitive(),
                    expirationDate: primitive(),
                },
                props
            )
        );
    }
    static createCoordinatorSchema(model, props) {
        // Coordinator
        return createModelSchema(
            model,
            Object.assign(
                {
                    coordinatorId: identifier(),
                    aspNetUserId: primitive(),
                    name: primitive(),
                    email: primitive(),
                    disabled: primitive(),
                    displayName: primitive(),
                    partitionId: primitive(),
                },
                props
            )
        );
    }
    static createAgentSchema(model, props) {
        // Agent
        return createModelSchema(
            model,
            Object.assign(
                {
                    agentId: identifier(),
                    aspNetUserId: primitive(),
                    agentContactId: primitive(),
                    email: primitive(),
                    preferredEmail: primitive(),
                    firstName: primitive(),
                    lastName: primitive(),
                    name: primitive(),
                    subscriberName: primitive(),
                    subscriberId: primitive(),
                },
                props
            )
        );
    }
    static createWatchAgentSchema(model, props) {
        // WatchAgent
        return createModelSchema(
            model,
            Object.assign(
                {
                    watchAgentId: identifier(),
                    agentContactId: primitive(),
                    email: primitive(),
                    firstName: primitive(),
                    lastName: primitive(),
                    name: primitive(),
                    subscriberName: primitive(),
                    subscriberId: primitive(),
                },
                props
            )
        );
    }
    static createAgentProfileSchema(model, props) {
        // AgentProfile
        return createModelSchema(
            model,
            Object.assign(
                {
                    agentProfileId: identifier(),
                    agentContactId: primitive(),
                    referralType: primitive(),
                    salesRepresentative: primitive(),
                    preferences: primitive(),
                    notes: primitive(),
                    preferredEmail: primitive(),
                },
                props
            )
        );
    }
    static createWorkflowStepStateSchema(model, props) {
        // WorkflowStepState
        return createModelSchema(
            model,
            Object.assign(
                {
                    workflowStepStateId: identifier(),
                    tcFileId: primitive(),
                    stepId: primitive(),
                    isComplete: primitive(),
                    isSkipped: primitive(),
                },
                props
            )
        );
    }
    static createFeatureFlagSchema(model, props) {
        // FeatureFlag
        return createModelSchema(
            model,
            Object.assign(
                {
                    featureFlagId: identifier(),
                    featureName: primitive(),
                    partitionId: identifier(),
                },
                props
            )
        );
    }
    static createTimelineEventSchema(model, props) {
        // TimelineEvent
        return createModelSchema(
            model,
            Object.assign(
                {
                    timelineEventId: identifier(),
                    state: primitive(),
                    order: primitive(),
                    name: primitive(),
                    days: primitive(),
                    weekendsCount: primitive(),
                    holidaysCount: primitive(),
                    canLandOnWeekend: primitive(),
                    canLandOnHoliday: primitive(),
                    exclude: primitive(),
                    reminders: primitive(),
                    recurrences: primitive(),
                    eventType: primitive(),
                    excludeFromWorkflow: primitive(),
                    excludeFromEmailGrid: primitive(),
                    excludeFromCalendarReminders: primitive(),
                },
                props
            )
        );
    }
    static createBrokerageProfileSchema(model, props) {
        // BrokerageProfile
        return createModelSchema(
            model,
            Object.assign(
                {
                    brokerageProfileId: identifier(),
                    subscriberId: primitive(),
                    preferences: primitive(),
                },
                props
            )
        );
    }
    static createEmailTemplateSchema(model, props) {
        return createModelSchema(
            model,
            Object.assign(
                {
                    id: identifier(),
                    name: primitive(),
                    subject: primitive(),
                    body: primitive(),
                    settings: emailTemplateSettingsSchema(),
                },
                props
            )
        );
    }

    static createGenericModelSchema(model, schema, props) {
        return createModelSchema(model, schema, props);
    }
}



// WEBPACK FOOTER //
// ./src/shared/model-schema.js